export const ActionTypes = {
  FETCH_ALL: 'services/productAttributes/fetch_all',
  FETCH_ALL_PRODUCT_ATTRIBUTES_OPTIONS: 'services/productAttributes/fetch_all_product_attributes_options',
  FETCH_ALL_GLOBAL_ATTRIBUTES: 'services/productAttributes/fetch_all_global_attributes',
  FETCH_ALL_SUCCESS: 'services/productAttributes/fetch_all_success',
  FETCH_ALL_DATA_TYPES: 'services/products/fetch_all_data_types',
  FETCH_PRODUCT_ATTRIBUTE_BY_ID: 'services/products/fetch_product_attribute_by_id',
  SET_PRODUCT_ATTRIBUTE_BY_ID: 'services/products/set_product_attribute_by_id',
  SET_LOADER_STATUS: 'services/productAttributes/set_loader_status',
  SET_EXPORT_GLOBAL_ATTRIBUTE_DATA_EXPORT_LOADER_STATUS:
    'services/productAttributes/set_export_global_attribute_data_export_loader_status',
  SET_DATA_TYPES: 'services/productAttributes/set_data_types',
  SET_ALL: 'services/productAttributes/set_all',
  SET_ALL_GLOBAL_ATTRIBUTES: 'services/productAttributes/set_all_global_attributes',
  SET_ALL_PRODUCT_ATTRIBUTES_OPTIONS: 'services/productAttributes/set_all_product_attributes_options',
  ADD_OR_UPDATE_PRODUCT_ATTRIBUTE: 'services/productAttribute/add_or_update_productAttribute',
  DELETE_PRODUCT_ATTRIBUTE: 'services/productAttribute/delete_productAttribute',
  GET_ALL_CSV_DATA: 'services/productAttribute/get_all_csv_data',
  SET_EXPORT_GLOBAL_ATTRIBUTE_DATA: 'services/productAttribute/set_export_global_attribute_data',
  PRODUCT_ATTRIBUTE_IMPORT: 'services/productAttribute/product_attributes_import',
  SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_FILE: 'services/productAttribute/set_import_excel_product_attributes_file',
  SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_FILE_LOADER_STATUS:
    'services/productAttribute/set_import_excel_product_attributes_file_loader_status',
  GET_ALL_GLOBAL_ATTRIBUTES: 'services/productAttributes/get_all_global_attributes',
  ADD_DATE_FORMAT: 'services/productAttributes/add_date_format',
  DELETE_DATE_FORMAT: 'services/productAttributes/delete_date_format',
};

const fetchAll = ({ productAttributeParams }) => ({
  productAttributeParams,
  type: ActionTypes.FETCH_ALL,
});

const fetchAllProductAttributesOptions = () => ({
  type: ActionTypes.FETCH_ALL_PRODUCT_ATTRIBUTES_OPTIONS,
});

const fetchAllGlobalAttributes = () => ({
  type: ActionTypes.FETCH_ALL_GLOBAL_ATTRIBUTES,
});

const getAllGlobalAttributes = () => ({
  type: ActionTypes.GET_ALL_GLOBAL_ATTRIBUTES,
});

const addDateFormat = ({ formatString, dataTypeId, onSuccess }) => ({
  formatString,
  dataTypeId,
  onSuccess,
  type: ActionTypes.ADD_DATE_FORMAT,
});

const deleteDateFormat = ({ id, onSuccess }) => ({
  id,
  onSuccess,
  type: ActionTypes.DELETE_DATE_FORMAT,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchAllDataTypes = () => ({
  type: ActionTypes.FETCH_ALL_DATA_TYPES,
});

const fetchProductAttributeById = ({ id }) => ({
  id,
  type: ActionTypes.FETCH_PRODUCT_ATTRIBUTE_BY_ID,
});

const setAllDataTypes = ({ allDataTypes }) => ({
  allDataTypes,
  type: ActionTypes.SET_DATA_TYPES,
});

const setAll = ({ allProductAttribute }) => ({
  allProductAttribute,
  type: ActionTypes.SET_ALL,
});

const setAllGlobalAttributes = ({ allGlobalAttributes }) => ({
  allGlobalAttributes,
  type: ActionTypes.SET_ALL_GLOBAL_ATTRIBUTES,
});

const setAllProductAttributesOptions = ({ allProductAttributeOptions }) => ({
  allProductAttributeOptions,
  type: ActionTypes.SET_ALL_PRODUCT_ATTRIBUTES_OPTIONS,
});

const addorUpdateProductAttribute = ({ productAttributeData, actionName, productAttributeParams, onSuccess }) => ({
  productAttributeData,
  actionName,
  productAttributeParams,
  onSuccess,
  type: ActionTypes.ADD_OR_UPDATE_PRODUCT_ATTRIBUTE,
});

const deleteProductAttribute = ({ id, productAttributeParams }) => ({
  id,
  productAttributeParams,
  type: ActionTypes.DELETE_PRODUCT_ATTRIBUTE,
});

const setProductAttributeById = ({ productAttributeById }) => ({
  productAttributeById,
  type: ActionTypes.SET_PRODUCT_ATTRIBUTE_BY_ID,
});

const GetAllCSVData = () => ({
  type: ActionTypes.GET_ALL_CSV_DATA,
});

const setGlobalAttributeExportDataLoader = ({ showGlobalAttributeExportDataLoader }) => ({
  showGlobalAttributeExportDataLoader,
  type: ActionTypes.SET_EXPORT_GLOBAL_ATTRIBUTE_DATA_EXPORT_LOADER_STATUS,
});

const setGlobalAttributesDataExport = ({ globalAttributeExportCSVData }) => ({
  globalAttributeExportCSVData,
  type: ActionTypes.SET_EXPORT_GLOBAL_ATTRIBUTE_DATA,
});

const importExcelProductAttributeFile = ({ importFileParams, productAttributeParams }) => ({
  importFileParams,
  productAttributeParams,
  type: ActionTypes.PRODUCT_ATTRIBUTE_IMPORT,
});

const setImportExcelToolFile = ({ importProductAttributeFile }) => ({
  importProductAttributeFile,
  type: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_FILE,
});

const setImportExcelToolFileLoader = ({ importExcelFileLoader }) => ({
  importExcelFileLoader,
  type: ActionTypes.SET_IMPORT_EXCEL_PRODUCT_ATTRIBUTE_FILE_LOADER_STATUS,
});

export default {
  fetchAll,
  fetchAllProductAttributesOptions,
  setAll,
  fetchAllDataTypes,
  fetchProductAttributeById,
  setAllDataTypes,
  setAllProductAttributesOptions,
  fetchAllGlobalAttributes,
  setAllGlobalAttributes,
  setLoader,
  setGlobalAttributeExportDataLoader,
  addorUpdateProductAttribute,
  deleteProductAttribute,
  setProductAttributeById,
  GetAllCSVData,
  setGlobalAttributesDataExport,
  importExcelProductAttributeFile,
  setImportExcelToolFile,
  setImportExcelToolFileLoader,
  getAllGlobalAttributes,
  addDateFormat,
  deleteDateFormat,
};
